export const SERVER_DOCUMENT = [
  "## Resumo de custos",
  "",
  "Estimativas com preços AWS On-Demand na região `sa-east-1`, sem incluir tráfego de saída, snapshots, armazenamento adicional, logs do CloudWatch, impostos ou descontos.",
  "",
  "| Servidor / cenário | Total semanal | Total mensal aproximado |",
  "|---|---:|---:|",
  "| Servidor de Projetos e Websites | **US$ 7,22** | **US$ 31,38** |",
  "| Servidor de Desenvolvimento e Testes — uso eventual | **US$ 4,63** | **US$ 18,52** |",
  "| Servidor de Desenvolvimento e Testes — ligado continuamente | **US$ 13,60** | **US$ 59,11** |",
  "| Servidor do Credenciamento | **US$ 7,04** | **US$ 30,58** |",
  "| Servidor de Produção | **US$ 15,07** | **US$ 65,51** |",
  "| Servidor de Banco de Dados | **US$ 6,85** | **US$ 29,77** |",
  "",
  "### Totais consolidados",
  "",
  "- **Servidores ativos, sem o ambiente de desenvolvimento:** **US$ 36,18 por semana** e **US$ 157,24 por mês**.",
  "- **Todos os servidores ligados continuamente:** **US$ 49,78 por semana** e **US$ 216,35 por mês**.",
  "- **Com o desenvolvimento em uso eventual:** **US$ 40,81 por semana em média** e **US$ 175,76 por mês**.",
  "",
  "",
  "Servidor de Projetos e Websites",
  "",
  "## 1. Objetivo do servidor",
  "",
  "Este servidor é utilizado para publicação de websites, páginas de cadastro e projetos adicionais da empresa. Ele funciona como uma área central para disponibilizar projetos sem misturar o conteúdo de cada website no documento de infraestrutura.",
  "",
  "## 2. Identificação",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Finalidade | Hospedar websites, cadastros e projetos adicionais |",
  "| Ambiente | Projetos / publicação web |",
  "| Provedor | AWS EC2 |",
  "| Região | São Paulo — `sa-east-1` |",
  "| Tipo da instância | `t3.small` |",
  "| Sistema operacional | Debian GNU/Linux 12 |",
  "| Hostname | `ip-172-31-9-250` |",
  "| Instance ID | `i-0b4fe14068e6eff2d` |",
  "| IP público atual | `56.125.127.53` |",
  "| IP privado | `172.31.9.250` |",
  "",
  "## 3. Recursos de infraestrutura",
  "",
  "| Recurso | Informação |",
  "|---|---:|",
  "| CPU | 2 vCPUs |",
  "| Memória | Aproximadamente 2 GB |",
  "| Swap | 4 GB |",
  "| Disco principal | 40 GB, com 41% utilizado |",
  "| Arquitetura | x86-64 |",
  "",
  "## 4. Websites e áreas de publicação",
  "",
  "O Apache publica duas áreas principais. O conteúdo interno de cada área não faz parte desta apresentação.",
  "",
  "| Subdomínio | Finalidade | Diretório de publicação |",
  "|---|---|---|",
  "| `cadastros.r1eventech.com.br` | Websites e páginas de cadastro | `/opt/bitnami/cadastros` |",
  "| `projetos.r1eventech.com.br` | Outros projetos e websites | `/opt/bitnami/projetos` |",
  "",
  "Os dois subdomínios também possuem a versão correspondente com `www`.",
  "",
  "## 5. Serviço de testes",
  "",
  "O servidor possui uma ferramenta de teste de WebSocket acessível pelo subdomínio de projetos:",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Rota | `https://projetos.r1eventech.com.br/tester/` |",
  "| Serviço | API do WebSocket Tester |",
  "| Processo | PM2 — `websocket-tester-api` |",
  "| Porta interna | `8090` |",
  "| Situação | Online |",
  "",
  "Também existem rotas internas para testes de WebSocket em `/ws` e `/sum-ws`.",
  "",
  "## 6. Tecnologia e operação",
  "",
  "| Componente | Situação |",
  "|---|---|",
  "| Apache | Versão 2.4.62 — ativo |",
  "| Node.js | Versão 18.20.4 |",
  "| npm | Versão 10.7.0 |",
  "| PM2 | Versão 6.0.13 |",
  "| Redis | Ativo, acesso local |",
  "| Git | Versão 2.39.5 |",
  "| CloudWatch | Ativo |",
  "",
  "Este servidor não foi identificado como servidor de banco de dados. O único serviço auxiliar identificado foi o Redis local.",
  "",
  "## 7. HTTPS e certificados",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Configuração Apache | `/opt/bitnami/apache/conf/bitnami/bitnami-ssl.conf` |",
  "| Autoridade certificadora | Let's Encrypt |",
  "| Certificado principal | `cadastros.r1eventech.com.br` |",
  "| Domínios cobertos | `cadastros.r1eventech.com.br` e `projetos.r1eventech.com.br` |",
  "| Validade observada | Até 2026-10-14 |",
  "| Renovação | Automatizada diariamente |",
  "",
  "## 8. Acesso e segurança",
  "",
  "O acesso administrativo é realizado por SSH utilizando uma chave privada autorizada. Os websites são publicados pelo Apache nas portas HTTP e HTTPS.",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Usuário administrativo | `bitnami` |",
  "| Porta SSH | `22` |",
  "| Serviços web | `80` e `443` |",
  "",
  "## 9. Backup do ambiente de projetos",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Última AMI específica do ambiente | `r1eventech - projects` |",
  "| AMI ID | `ami-02a81bc5b4f6449e7` |",
  "| Data/hora registrada | **2025-10-15 02:23 GMT-3** |",
  "| Status | Private — Available |",
  "| Sistema | Linux/UNIX — HVM |",
  "| Armazenamento | 40 GB EBS gp3 criptografado em `/dev/sda1` |",
  "| Snapshot | `snap-051b99d4278df3f86` |",
  "| Região | `sa-east-1` |",
  "",
  "A AMI genérica `Backup prod` é mais recente, com data de **2026-08-07 09:07 GMT-3**, mas não está identificada como backup específico do ambiente de projetos.",
  "",
  "## 10. Estimativa de custo semanal",
  "",
  "Estimativa para manter a instância ligada continuamente, utilizando preços On-Demand, 40 GB de EBS gp3 e um IPv4 público:",
  "",
  "| Componente | Premissa | Estimativa semanal |",
  "|---|---|---:|",
  "| EC2 `t3.small` | US$ 0,0336/h × 168 horas | **US$ 5,64** |",
  "| IPv4 público | US$ 0,005/h × 168 horas | **US$ 0,84** |",
  "| Disco EBS | 40 GB, assumindo volume gp3 | **US$ 0,74** |",
  "| **Total estimado** | Servidor ligado continuamente | **US$ 7,22** |",
  "",
  "Equivalente aproximado para um mês de 730 horas: **US$ 31,38**.",
  "",
  "Esta estimativa não inclui tráfego de saída, snapshots, armazenamento adicional, logs do CloudWatch, impostos ou descontos da conta AWS.",
  "",
  "---------------------------------------------------------------------------",
  "",
  "# Servidor de Desenvolvimento e Testes",
  "",
  "## 1. Objetivo do servidor",
  "",
  "Este servidor é utilizado ocasionalmente para desenvolvimento, homologação e testes das aplicações. Ele não foi identificado como ambiente de produção e não deve ser considerado disponível continuamente.",
  "",
  "## 2. Regra de funcionamento",
  "",
  "| Regra | Procedimento |",
  "|---|---|",
  "| Desligamento automático | Todos os dias às 20:00 UTC |",
  "| Horário equivalente em São Paulo | 17:00 |",
  "| Inicialização | Manual pelo painel da AWS |",
  "| Uso recomendado | Ligar somente quando houver necessidade de testes |",
  "",
  "### Como utilizar",
  "",
  "1. Acessar o painel da AWS e abrir o serviço EC2.",
  "2. Localizar a instância de desenvolvimento.",
  "3. Selecionar **Start instance / Iniciar instância**.",
  "4. Aguardar o status da instância ficar como **Running**.",
  "5. Realizar os testes necessários durante a janela de uso.",
  "6. O servidor será desligado automaticamente às 17:00 no horário de São Paulo.",
  "",
  "Não foi identificado um agendamento automático para ligar o servidor. Após o desligamento, ele precisa ser iniciado manualmente novamente quando houver necessidade.",
  "",
  "## 3. Identificação",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Finalidade | Desenvolvimento, homologação e testes |",
  "| Ambiente | Desenvolvimento |",
  "| Provedor | AWS EC2 |",
  "| Região | São Paulo — `sa-east-1` |",
  "| Tipo da instância | `t3.medium` |",
  "| Sistema operacional | Debian GNU/Linux 11 |",
  "| Hostname | `ip-172-31-6-163` |",
  "| Instance ID | `i-04bef2fa1f45dbfe2` |",
  "| IP público atual | `56.124.43.240` |",
  "| IP privado | `172.31.6.163` |",
  "",
  "## 4. Recursos de infraestrutura",
  "",
  "| Recurso | Informação |",
  "|---|---:|",
  "| CPU | 2 vCPUs |",
  "| Memória | Aproximadamente 4 GB |",
  "| Swap | 8 GB |",
  "| Disco principal | 80 GB, com 46% utilizado |",
  "| Arquitetura | x86-64 |",
  "",
  "## 5. Aplicações e projetos",
  "",
  "| Projeto | Função | Situação |",
  "|---|---|---|",
  "| `flex-interativa-server` | API principal | Online |",
  "| `flex-interativa-credenciamento-server` | API de credenciamento | Online |",
  "| `rfid-websocket-api` | Integrações RFID | Online |",
  "| `flex-interativa-plataforma-eventos-server` | Serviços da plataforma de eventos | Online |",
  "| `flex-interativa-webapps-server` | Serviços das aplicações web | Online |",
  "| `flex-interativa-credenciamento` | Interface de credenciamento | Disponível para testes |",
  "| `flex-interativa-plataforma-eventos` | Interface da plataforma de eventos | Disponível para testes |",
  "| `flex-interativa-webapps` | Interfaces das aplicações | Disponível para testes |",
  "| `flex-interativa-painel` | Interface do painel | Disponível para testes |",
  "| `flex-interativa-landing` | Landing page | Presente no servidor |",
  "",
  "## 6. Domínios de desenvolvimento",
  "",
  "| Domínio | Finalidade |",
  "|---|---|",
  "| `api-dev.r1eventech.com.br` | API principal de desenvolvimento |",
  "| `api-credenciamento-dev.r1eventech.com.br` | API de credenciamento |",
  "| `api-apps-dev.r1eventech.com.br` | APIs das aplicações web |",
  "| `websocket-dev.r1eventech.com.br` | WebSocket e eventos |",
  "| `images-dev.r1eventech.com.br` | Imagens de desenvolvimento |",
  "| `minigames-dev.r1eventech.com.br` | Minigames de desenvolvimento |",
  "| `painel-dev.r1eventech.com.br` | Painel de desenvolvimento |",
  "| `credenciamento-dev.r1eventech.com.br` | Interface de credenciamento |",
  "| `eventos-dev.r1eventech.com.br` | Interface de eventos |",
  "| `aplicativos-dev.r1eventech.com.br` | Aplicações web |",
  "",
  "## 7. Ambiente de software",
  "",
  "| Software/serviço | Versão/estado |",
  "|---|---|",
  "| Apache | 2.4.58 — ativo |",
  "| Node.js | 18.19.0 |",
  "| npm | 10.2.3 |",
  "| PM2 | 5.3.1 — inicialização automática habilitada |",
  "| MariaDB | 10.5.29 — ativo |",
  "| Redis | Ativo, acesso local |",
  "| Git | 2.30.2 |",
  "| CloudWatch | Ativo |",
  "",
  "## 8. Especificações de WebSocket",
  "",
  "O servidor de desenvolvimento hospeda o serviço WebSocket para testes de gerenciamento de conexões em tempo real.",
  "",
  "| Capacidade | Especificação |",
  "|---|---|",
  "| Máximo de conexões simultâneas | **5000 conexões** |",
  "| Domínio | `websocket-dev.r1eventech.com.br` |",
  "| Protocolo | Socket.IO via HTTPS |",
  "| Ambiente | Desenvolvimento e testes |",
  "| Disponibilidade | Conforme agendamento do servidor (desliga às 17:00 São Paulo) |",
  "",
  "Esta capacidade aplica-se ao servidor de desenvolvimento e garante que até 5000 conexões simultâneas podem ser testadas para validação de comportamento em tempo real.",
  "",
  "## 9. Backups",
  "",
  "O servidor possui backup diário do banco de dados, executado às 06:00 UTC. Os arquivos são armazenados localmente no servidor.",
  "",
  "## 9. Acesso e segurança",
  "",
  "O acesso administrativo é realizado por SSH utilizando uma chave privada autorizada. Os serviços web utilizam HTTPS, e os serviços internos são administrados pelo PM2 e pelo Bitnami.",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Usuário administrativo | `bitnami` |",
  "| Porta SSH | `22` |",
  "| Serviços web | `80` e `443` |",
  "| Banco de desenvolvimento | MariaDB na porta `3306` |",
  "",
  "## 10. Estimativa de custo",
  "",
  "Estimativa de referência para a região `sa-east-1`, utilizando preços On-Demand, uma instância `t3.medium`, 80 GB de EBS gp3 e um IPv4 público. No uso eventual, considera-se a instância ligada por 7 dias totais no mês, 24 horas por dia (168 horas):",
  "",
  "| Cenário | Estimativa semanal |",
  "|---|---:|",
  "| Servidor ligado continuamente | **US$ 13,60** |",
  "| Uso eventual — 42h por semana em média (168h/mês) | **US$ 4,63** |",
  "| Custo aproximado do disco mesmo desligado | **US$ 1,47** |",
  "",
  "Nesse cenário eventual, o custo mensal aproximado é **US$ 18,52**, considerando o período ligado de EC2 e IPv4 e o armazenamento EBS durante o mês. Desligar o servidor fora desses 7 dias reduz o custo de computação; o armazenamento EBS continua sendo cobrado enquanto existir.",
  "---------------------------------------------------------------",
  "",
  "Servidor do Credenciamento",
  "",
  "## 1. Visão geral",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Finalidade | Hospedar o sistema de credenciamento |",
  "| Ambiente | Produção |",
  "| Provedor | AWS EC2 |",
  "| Região | São Paulo — `sa-east-1` |",
  "| Tipo da instância | `t3.small` |",
  "| Sistema operacional | Ubuntu 24.04.2 LTS |",
  "",
  "## 2. Sistemas hospedados",
  "",
  "| Sistema | Função | Status |",
  "|---|---|---|",
  "| Credenciamento | Interface utilizada pelos usuários | Ativo |",
  "| API de Credenciamento | Serviços e integrações do sistema | Ativo |",
  "",
  "### Projetos identificados em `/var/www/projects`",
  "",
  "| Projeto | Função | Tecnologia | Caminho | Porta |",
  "|---|---|---|---|---:|",
  "| `flex-interativa-credenciamento` | Interface do sistema | React / Node.js | `/var/www/projects/flex-interativa-credenciamento` | Apache/HTTPS |",
  "| `flex-interativa-credenciamento-server` | API e integrações | Node.js | `/var/www/projects/flex-interativa-credenciamento-server` | `8082` |",
  "",
  "### Domínios utilizados",
  "",
  "- `credenciamento.r1eventech.com.br`",
  "- `www.credenciamento.r1eventech.com.br`",
  "- `api-credenciamento.r1eventech.com.br`",
  "- `www.api-credenciamento.r1eventech.com.br`",
  "",
  "## 3. Infraestrutura",
  "",
  "| Recurso | Informação |",
  "|---|---:|",
  "| CPU | 2 vCPUs |",
  "| Memória | Aproximadamente 2 GB |",
  "| Disco | 30 GB, com 34% utilizado |",
  "| IP público | `56.126.6.150` |",
  "| IP privado | `172.31.2.190` |",
  "",
  "## 10. Acesso e segurança",
  "",
  "O acesso administrativo é realizado por SSH, utilizando uma chave privada autorizada. Os serviços públicos utilizam HTTP/HTTPS, e o acesso administrativo deve permanecer restrito à equipe responsável.",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Usuário de acesso | `ubuntu` |",
  "| Porta administrativa | `22` |",
  "| Serviços web | `80` e `443` |",
  "",
  "## 5. Operação do sistema",
  "",
  "O Apache recebe as solicitações dos domínios. A interface do sistema é publicada pelo servidor, enquanto a API funciona como um serviço Node.js.",
  "",
  "| Componente | Situação |",
  "|---|---|",
  "| Servidor web Apache | Ativo — versão 2.4.58 |",
  "| Node.js | Versão 22.16.0 |",
  "| API Node.js | Online via PM2 |",
  "| Inicialização automática | Ativa |",
  "| Monitoramento AWS CloudWatch | Ativo |",
  "",
  "## 6. Configuração HTTPS do Apache",
  "",
  "| Domínio HTTPS | Alias | Função | Configuração |",
  "|---|---|---|---|",
  "| `credenciamento.r1eventech.com.br` | `www.credenciamento.r1eventech.com.br` | Interface do sistema | `/etc/apache2/sites-enabled/certs2.conf` |",
  "| `api-credenciamento.r1eventech.com.br` | `www.api-credenciamento.r1eventech.com.br` | API | `/etc/apache2/sites-enabled/certs2.conf` |",
  "",
  "### Encaminhamento dos serviços",
  "",
  "- O domínio `credenciamento.r1eventech.com.br` serve o frontend a partir de `/var/www/projects/flex-interativa-credenciamento/build`.",
  "- O domínio `api-credenciamento.r1eventech.com.br` encaminha as requisições para a API Node.js em `https://localhost:8082/`.",
  "- O certificado utilizado está localizado em `/etc/letsencrypt/live/credenciamento.r1eventech.com.br/`.",
  "",
  "## 7. Certificados digitais",
  "",
  "Os domínios atuais utilizam certificado digital válido, com renovação automática configurada.",
  "",
  "| Item | Situação |",
  "|---|---|",
  "| Certificado atual | Válido até 2026-09-11 |",
  "| Renovação | Automática pelo Certbot |",
  "",
  "## 8. Backups",
  "",
  "| Item | Processo atual |",
  "|---|---|",
  "| Arquivos dos projetos | Backup manual, normalmente a cada 3 meses |",
  "| Banco de dados | Possui rotina própria de backup |",
  "",
  "## 9. Deploy",
  "",
  "O código é atualizado no GitHub e, quando necessário, a equipe técnica atualiza manualmente a versão instalada no servidor.",
  "",
  "O processo envolve:",
  "",
  "1. Atualizar o código no GitHub.",
  "2. Atualizar a cópia do projeto no servidor.",
  "3. Gerar a nova versão da interface.",
  "4. Reiniciar a API.",
  "5. Validar o funcionamento do sistema.",
  "",
  "Atualmente não foi identificado um processo automático de publicação a partir do GitHub.",
  "",
  "## 10. Estimativa de custo semanal",
  "",
  "Estimativa para manter a instância ligada continuamente, utilizando preços On-Demand e sem considerar créditos ou descontos:",
  "",
  "| Componente | Premissa | Estimativa semanal |",
  "|---|---|---:|",
  "| EC2 `t3.small` | US$ 0,0336/h × 168 horas | **US$ 5,64** |",
  "| IPv4 público | US$ 0,005/h × 168 horas | **US$ 0,84** |",
  "| Disco EBS | 30 GB, assumindo volume gp3 | **US$ 0,55** |",
  "| **Total estimado** | 24 horas por dia, 7 dias por semana | **US$ 7,04** |",
  "",
  "Equivalente aproximado para um mês de 730 horas: **US$ 30,58**.",
  "",
  "Esta estimativa não inclui tráfego de saída, snapshots, armazenamento adicional, custos do banco de dados, logs do CloudWatch, créditos de CPU do modo Unlimited, impostos ou eventuais descontos da conta AWS.",
  "",
  "-------------------------------------------------------------------------",
  "",
  "# Servidor de Produção",
  "",
  "## 1. Visão geral",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Finalidade | Hospedar APIs, aplicações web, WebSocket |",
  "| Ambiente | Produção |",
  "| Provedor | AWS EC2 |",
  "| Região | São Paulo — `sa-east-1` |",
  "| Tipo da instância | `t3.medium` |",
  "| Sistema operacional | Debian GNU/Linux 11 |",
  "| Hostname | `ip-172-31-14-53` |",
  "| Instance ID | `i-08523ec0746d9027c` |",
  "| IP público | `52.67.223.25` |",
  "| IP privado | `172.31.14.53` |",
  "",
  "## 2. Recursos de infraestrutura",
  "",
  "| Recurso | Informação |",
  "|---|---:|",
  "| CPU | 2 vCPUs |",
  "| Memória | Aproximadamente 4 GB |",
  "| Swap | 8 GB |",
  "| Disco principal | 160 GB, com 55% utilizado |",
  "| Arquitetura | x86-64 |",
  "",
  "## 3. Aplicações e projetos",
  "",
  "| Projeto | Função | Tecnologia | Situação |",
  "|---|---|---|---|",
  "| `flex-interativa-server` | API principal | Node.js / PM2 | Online |",
  "| `rfid-websocket-api` | Integrações RFID e WebSocket | Node.js / PM2 | Online |",
  "| `flex-interativa-webapps-server` | API das aplicações web | Node.js / PM2 | Online |",
  "| `flex-interativa-plataforma-eventos-server` | Serviços da plataforma de eventos | Node.js / PM2 | Online |",
  "| `flex-interativa-painel` | Interface do painel | Aplicação web | Publicada |",
  "| `flex-interativa-plataforma-eventos` | Interface da plataforma de eventos | Aplicação web | Publicada |",
  "| `flex-interativa-webapps` | Interfaces das aplicações | Aplicação web | Publicada |",
  "| `flex-interativa-server/images` | Arquivos e imagens públicas | Arquivos estáticos | Publicado |",
  "| `/opt/bitnami/minigames` | Coleção de minigames | Conteúdo web | Publicado |",
  "",
  "Também foi identificado um projeto de landing page no diretório de projetos.",
  "",
  "## 4. Domínios e HTTPS",
  "",
  "O Apache concentra as configurações HTTPS e utiliza um certificado Let's Encrypt compartilhado entre os domínios principais.",
  "",
  "| Domínio | Função | Destino principal |",
  "|---|---|---|",
  "| `api.r1eventech.com.br` | API principal | Node.js na porta `8000` |",
  "| `api-apps.r1eventech.com.br` | APIs das aplicações | Node.js na porta `8080` |",
  "| `websocket.r1eventech.com.br` | WebSocket e serviços de eventos | Node.js na porta `8081` |",
  "| `images.r1eventech.com.br` | Imagens públicas | `/opt/bitnami/projects/flex-interativa-server/images` |",
  "| `minigames.r1eventech.com.br` | Minigames | `/opt/bitnami/minigames` |",
  "| `painel.r1eventech.com.br` | Painel administrativo | `/opt/bitnami/projects/flex-interativa-painel/build` |",
  "| `eventos.r1eventech.com.br` | Plataforma de eventos | `/opt/bitnami/projects/flex-interativa-plataforma-eventos/build` |",
  "| `aplicativos.r1eventech.com.br` | Aplicações web | `/opt/bitnami/projects/flex-interativa-webapps/build` |",
  "",
  "Todos os domínios possuem também o alias correspondente com `www`.",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Apache | Versão 2.4.54 |",
  "| Configuração HTTPS | `/opt/bitnami/apache/conf/bitnami/bitnami-ssl.conf` |",
  "| Certificado | Let's Encrypt |",
  "| Validade observada | Até 2026-10-02 |",
  "| Renovação | Automatizada |",
  "",
  "## 5. Serviços em operação",
  "",
  "| Serviço | Situação |",
  "|---|---|",
  "| Apache | Ativo |",
  "| Redis | Ativo, acesso local ao servidor |",
  "| API principal | Online via PM2 |",
  "| Aplicações web | Online via PM2 |",
  "| WebSocket | Online via PM2 |",
  "| Amazon CloudWatch | Ativo |",
  "| Fail2ban | Ativo |",
  "| Atualizações automáticas | Ativas |",
  "",
  "## 6. Ambiente de software",
  "",
  "| Software | Versão/estado |",
  "|---|---|",
  "| Node.js | 18.19.0 |",
  "| npm | 10.9.2 |",
  "| PM2 | 6.0.5 |",
  "| Git | 2.30.2 |",
  "| PHP | Não instalado |",
  "| MySQL | Não instalado neste servidor |",
  "",
  "## 7. Especificações de WebSocket",
  "",
  "O servidor de produção hospeda o serviço WebSocket para gerenciamento de conexões em tempo real entre clientes e a plataforma.",
  "",
  "| Capacidade | Especificação |",
  "|---|---|",
  "| Máximo de conexões simultâneas | **5000 conexões** |",
  "| Domínio | `websocket.r1eventech.com.br` |",
  "| Porta interna | `8081` |",
  "| Protocolo | Socket.IO via HTTPS |",
  "| Status | Online via PM2 |",
  "",
  "Esta capacidade aplica-se ao servidor de produção e garante que até 5000 usuários podem estar conectados simultaneamente ao serviço de eventos em tempo real.",
  "",
  "## 8. Acesso e segurança",
  "",
  "O acesso administrativo é feito por SSH utilizando uma chave privada autorizada. Os serviços públicos utilizam HTTP/HTTPS, enquanto os serviços Node.js funcionam internamente e são publicados pelo Apache.",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Usuário administrativo | `bitnami` |",
  "| Porta SSH | `22` |",
  "| Serviços web públicos | `80` e `443` |",
  "| Redis | Porta `6379`, acesso local |",
  "",
  "## 9. Estimativa de custo semanal",
  "",
  "Estimativa para manter a instância ligada continuamente, utilizando preços On-Demand e sem considerar créditos ou descontos:",
  "",
  "| Componente | Premissa | Estimativa semanal |",
  "|---|---|---:|",
  "| EC2 `t3.medium` | US$ 0,0672/h × 168 horas | **US$ 11,29** |",
  "| IPv4 público | US$ 0,005/h × 168 horas | **US$ 0,84** |",
  "| Disco EBS | 160 GB, assumindo volume gp3 | **US$ 2,94** |",
  "| **Total estimado** | 24 horas por dia, 7 dias por semana | **US$ 15,07** |",
  "",
  "Equivalente aproximado para um mês de 730 horas: **US$ 65,51**.",
  "",
  "Esta estimativa não inclui tráfego de saída, snapshots, armazenamento adicional, logs do CloudWatch, impostos ou descontos da conta AWS.",
  "",
  "-------------------------------------------------------------------------",
  "",
  "# Servidor de Banco de Dados",
  "",
  "## 1. Visão geral",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Finalidade | Hospedar os bancos de dados utilizados pelas aplicações |",
  "| Ambiente | Produção |",
  "| Provedor | AWS EC2 |",
  "| Região | São Paulo — `sa-east-1` |",
  "| Tipo da instância | `t3.small` |",
  "| Sistema operacional | Amazon Linux 2023 |",
  "| Memória | Aproximadamente 2 GB |",
  "| Disco | 20 GB, com 34% utilizado |",
  "",
  "## 2. Bancos de dados",
  "",
  "| Banco | Finalidade | Situação |",
  "|---|---|---|",
  "| `plataforma_eventos` | Banco de aplicação | Ativo |",
  "| `r1_events` | Banco de aplicação | Ativo |",
  "| `r1_data` | Banco de aplicação | Ativo |",
  "| `minigames` | Banco de aplicação | Ativo |",
  "",
  "O servidor também possui bancos internos necessários para o funcionamento do MySQL.",
  "",
  "## 3. Tecnologia e operação",
  "",
  "| Componente | Situação |",
  "|---|---|",
  "| MySQL | Ativo — versão 8.0.33 |",
  "| Serviço do banco | Ativo e configurado para iniciar automaticamente |",
  "| Monitoramento AWS CloudWatch | Ativo |",
  "| AWS Systems Manager | Ativo |",
  "| Sincronização de horário | Ativa, utilizando UTC |",
  "",
  "Não foram identificados outros serviços de banco de dados ativos, como PostgreSQL, MongoDB, MariaDB ou Redis.",
  "",
  "## 4. Acesso e segurança",
  "",
  "O banco deve ser acessado pelos servidores de aplicação autorizados, preferencialmente por meio do IP privado. O acesso administrativo é feito por SSH utilizando uma chave privada autorizada.",
  "",
  "| Item | Informação |",
  "|---|---|",
  "| Usuário administrativo | `ec2-user` |",
  "| Porta SSH | `22` |",
  "| Porta do MySQL | `3306` |",
  "| IP público | `54.94.145.254` |",
  "| IP privado | `172.31.5.114` |",
  "",
  "## 5. Backups",
  "",
  "| Item | Processo atual |",
  "|---|---|",
  "| Frequência | Duas vezes ao dia |",
  "| Horários aproximados em São Paulo | 03:00 e 15:00 |",
  "| Formato | Arquivos comprimidos do banco |",
  "| Destino atual | Diretório de backup no próprio servidor |",
  "| Último backup observado | 2026-08-06 às 06:00 UTC |",
  "",
  "Foram identificados arquivos recentes de backup do banco `plataforma_eventos`.",
  "",
  "## 6. Manutenção e suporte",
  "",
  "O servidor possui serviços ativos de monitoramento, gerenciamento remoto, auditoria, sincronização de horário e rotação de logs.",
  "",
  "## 7. Estimativa de custo semanal",
  "",
  "Estimativa para manter a instância ligada continuamente, utilizando preços On-Demand e sem considerar créditos ou descontos:",
  "",
  "| Componente | Premissa | Estimativa semanal |",
  "|---|---|---:|",
  "| EC2 `t3.small` | US$ 0,0336/h × 168 horas | **US$ 5,64** |",
  "| IPv4 público | US$ 0,005/h × 168 horas | **US$ 0,84** |",
  "| Disco EBS | 20 GB, assumindo volume gp3 | **US$ 0,37** |",
  "| **Total estimado** | 24 horas por dia, 7 dias por semana | **US$ 6,85** |",
  "",
  "Equivalente aproximado para um mês de 730 horas: **US$ 29,77**.",
  "",
  "Esta estimativa não inclui tráfego de saída, snapshots, armazenamento adicional, logs do CloudWatch, impostos ou descontos da conta AWS.",
].join("\n");
